const arrayIncludes = <T>(search: T, array: readonly T[]): boolean => {
  if (!Array.isArray(array)) {
    return false;
  }
  return array.indexOf(search) > -1;
};

export default arrayIncludes;
